import { useState } from "react";
import { motion, AnimateSharedLayout } from "framer-motion";
import "./styles.css";

export default function App() {
    const [wide, setWide] = useState(false);
    const boxes = [...Array(8).keys()];

    return (
        <div className="container">
            <AnimateSharedLayout>
                <motion.div
                    className="parent"
                    layout
                    style={{ width: wide ? 380 : 260 }}
                >
                    {boxes.map((id) => (
                        <Box key={id} />
                    ))}
                </motion.div>
            </AnimateSharedLayout>
            <div className="buttons">
                <motion.div
                    className="button"
                    style={{
                        backgroundColor: !wide && "#fff"
                    }}
                    onTap={() => setWide(false)}
                >
                    Default
                </motion.div>
                <motion.div
                    className="button"
                    style={{
                        backgroundColor: wide && "#fff"
                    }}
                    onTap={() => setWide(true)}
                >
                    Wider
                </motion.div>
            </div>
        </div>
    );
}

function Box(props) {
    const [wide, setWide] = useState(false);

    return (
        <motion.div
            className="box"
            layout
            style={{ width: wide ? 100 : 40 }}
            initial={{ borderRadius: 10 }}
            onTap={() => setWide(!wide)}
        />
    );
}
